const readIdFromIri = value => {
	if (!value || typeof value !== 'string') return null
	const parts = value.split('/')
	const id = Number(parts[parts.length - 1])
	return Number.isFinite(id) ? id : null
}

const getUserInitials = displayName => {
	if (!displayName || typeof displayName !== 'string') return '?'
	const words = displayName
		.trim()
		.split(/\s+/)
		.filter(Boolean)

	if (!words.length) return '?'
	return words
		.slice(0, 2)
		.map(word => word.charAt(0).toUpperCase())
		.join('')
}

const isSafeAvatarUrl = value => {
	if (!value || typeof value !== 'string') return false
	try {
		const baseUrl = typeof window !== 'undefined' ? window.location.origin : 'http://localhost'
		const url = new URL(value, baseUrl)
		if (['http:', 'https:'].includes(url.protocol)) return true
		return url.protocol === 'data:' && /^data:image\//i.test(value)
	} catch (error) {
		return false
	}
}

const normalizeMarkerUser = user => {
	if (!user) return null

	if (typeof user === 'string') {
		const id = readIdFromIri(user)
		if (!id) return null
		const displayName = `Uzytkownik ${id}`
		return {
			id,
			displayName,
			initials: getUserInitials(displayName),
			avatarUrl: null
		}
	}

	if (typeof user !== 'object') return null

	const id = user.id != null ? Number(user.id) : readIdFromIri(user['@id'])
	const displayName = user.googleName || user.username || user.name || (id ? `Uzytkownik ${id}` : '?')
	const avatarUrl = isSafeAvatarUrl(user.googlePicture || user.avatar || user.picture)
		? (user.googlePicture || user.avatar || user.picture)
		: null

	return {
		id: Number.isFinite(id) ? id : null,
		displayName,
		initials: getUserInitials(displayName),
		avatarUrl
	}
}

export {
	getUserInitials,
	isSafeAvatarUrl,
	normalizeMarkerUser
}
